import React from 'react';
import classnames from 'classnames';
import SubscribeButton from '../../../../Button/SubscribeButton';
import TierPricePerMonth from '../../../Helper/TierPricePerMonth';
import s from './PriceAndSubscribeButton.scss';
/** Price/month and subscribe button */
var PriceAndSubscribeButton = function (_a) {
    var _b, _c;
    var tier = _a.tier, className = _a.className;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        ((_b = tier.tier) === null || _b === void 0 ? void 0 : _b.dollarPrice) && (React.createElement(TierPricePerMonth, { className: s['price'], price: (_c = tier.tier) === null || _c === void 0 ? void 0 : _c.dollarPrice })),
        React.createElement(SubscribeButton, { className: s['subscribe-button'], tier: tier, href: tier.url, size: "small" })));
};
PriceAndSubscribeButton.displayName = 'PriceAndSubscribeButton';
export default PriceAndSubscribeButton;
//# sourceMappingURL=PriceAndSubscribeButton.js.map